/*
 * @Author: xiaoxi 2767862556@qq.com
 * @Date: 2022-06-06 13:30:44
 * @LastEditors: xiaoxi 2767862556@qq.com
 * @LastEditTime: 2022-06-15 13:54:55
 * @FilePath: \webpatient\src\components\hospitalBookTab\szhospitalBookTab\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  ComponentDataConfig: {
    title:"标题链接",
    list:[
      // {
      //   title:"网站预约",
      //   href: "/medicalCenter/websiteBook"
      // },
      {
        title:"微信预约",
        href: "/medicalCenter/wechatBook"
      },
      {
        title:"APP 预约",
        href: "/medicalCenter/appBook"
      },
      {
        title:"电话预约",
        href: "/medicalCenter/phoneBook"
      },
      {
        title:"一体机预约",
        href: "/medicalCenter/machineBook"
      },
    ]
    
  },
  ComponentStyleConfig: {   
    editorDOM: {
      margin: true,
      padding: true,
      background: true,
      showTxt: "外层容器"
    },
  },
  ComponentOtherConfig: [
    {
      componentId: "my-input-001", //对应组件id
      key: "activeId", //对应当前属性
      title: "选中按钮",
      default: "0",
      type: "DataAttr" //属性类型，当前为设置几列
    }
  ]
};
